import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { Box, Button, Text, Flex, Link } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-1JBXMGM9V4';
const COOKIE_CONSENT_KEY = 'cookie_consent_status';

export const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consentStatus = Cookies.get(COOKIE_CONSENT_KEY);
    if (!consentStatus) {
      setIsVisible(true);
    } else if (consentStatus === 'accepted') {
      initializeGoogleAnalytics();
    }
  }, []);

  const initializeGoogleAnalytics = () => {
    // Google Analytics is loaded in index.html, we just need to push consent update
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
      // Set the config again to ensure tracking begins
      (window as any).gtag('config', GA_MEASUREMENT_ID);
    }
  };

  const handleAccept = () => {
    Cookies.set(COOKIE_CONSENT_KEY, 'accepted', { expires: 365 }); // Remember for 1 year
    initializeGoogleAnalytics();
    setIsVisible(false);
  };

  const handleDecline = () => {
    Cookies.set(COOKIE_CONSENT_KEY, 'declined', { expires: 30 }); // Respect choice for 30 days
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <Box
      position="fixed"
      bottom="0"
      left="0"
      right="0"
      bg="#1A1A2E"
      color="white"
      p={4}
      zIndex={9999}
      boxShadow="0 -4px 10px rgba(0,0,0,0.5)"
      borderTop="1px solid rgba(197, 160, 106, 0.3)"
    >
      <Flex
        maxW="container.xl"
        mx="auto"
        direction={{ base: 'column', md: 'row' }}
        align="center"
        justify="space-between"
        gap={4}
      >
        <Box flex="1">
          <Text fontSize="sm" lineHeight="tall">
            Web sitemizde size en iyi deneyimi sunabilmek ve site trafiğimizi analiz etmek (Google Analytics) için çerezler kullanıyoruz. 
            Çerezleri kabul ederek bu verilere erişimimize izin vermiş olursunuz. Daha fazla bilgi için{' '}
            <Link as="span" color="#C5A06A" textDecoration="underline" _hover={{ color: 'white' }}>
              <RouterLink to="/gizlilik">Gizlilik Politikamızı</RouterLink>
            </Link>{' '}
            ve{' '}
            <Link as="span" color="#C5A06A" textDecoration="underline" _hover={{ color: 'white' }}>
              <RouterLink to="/kullanim-sartlari">Kullanım Şartlarımızı</RouterLink>
            </Link>{' '}
            inceleyebilirsiniz.
          </Text>
        </Box>
        <Flex gap={3} w={{ base: '100%', md: 'auto' }}>
          <Button
            onClick={handleDecline}
            variant="outline"
            borderColor="rgba(255, 255, 255, 0.3)"
            color="white"
            _hover={{ bg: 'rgba(255,255,255,0.1)' }}
            size="sm"
            flex={{ base: 1, md: 'auto' }}
          >
            Reddet
          </Button>
          <Button
            onClick={handleAccept}
            bg="#C5A06A"
            color="white"
            _hover={{ bg: '#b08d5b' }}
            size="sm"
            flex={{ base: 1, md: 'auto' }}
          >
            Kabul Et
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};